/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import LoadingAlert from "../LoadingAlert";
import { qreq } from "../../shared/qrequest";
import { SidebarGlobal } from "../_Sidebar";
import React from "react";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import FormLabel from "../FormLabel";
import Globals from "../../shared/Globals";
import Auth from "../../shared/Auth";
import AppActions from "../AppActions";
import './WorkorderView.css';
import { WorkorderCom } from "./WorkorderCom";
import { Dropdown } from "react-bootstrap";
import L from "../Lang";
import { Pop } from "../PopModal";
import WorkorderCommentList from "./WorkorderCommentList";
import LogHoursModal from "./LogHoursModal";
import Slider from "../Slider";
import { Modal } from "react-bootstrap";

class WorkorderView extends WorkorderCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {
                dueDate: new Date(),
                startDate: new Date(),
                attachments: []
            }
        };

        this.submitRef = React.createRef();
    }

    async componentDidMount() {
        await this.pullUserAsync();
        this.load();
        if (Auth.hasRole('tasker')) {
            SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={this.edit}>
                <Icon icon="faEdit" /> <span className="d-none d-md-inline"><L>Edit</L></span>
            </button>
                <button type="button" className="btn btn-warning" onClick={this.clock}>
                    <Icon icon="faClock" /> <span className="d-none d-md-inline"><L>Clock</L></span>
                </button>
            </>);
        }
        await this.fillListAsync('/api/workorder/status/list', 'statuses');
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    edit = () => {
        this.props.navigate('edit');
    }

    clock = () => {
        this.setState({ showLogHours: true });
    }

    load = () => {
        this.setState({ loading: true });
        if (this.props.params.id) {
            qreq.get('/api/workorder/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item)
                    this.setState({ item: j.item });
                this.setState({ loading: false });
            }, e => {
                this.unkownErrorCallback();
                this.goBack();
                this.setState({ loading: false });
            });
        }
        else
            this.setState({ item: {}, loading: false });
    }




    changeInfo = (a, b) => {
        let item = { ...this.state.item };
        item[a] = b;
        this.setState({ item });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    toggleShowAttachment = () => {
        this.setState({ showAddAttachment: !this.state.showAddAttachment });
    }

    downloadAttachment = (i) => {
        window.open(Globals.serverUrl + '/api/storage/file/' + i.fileIdent);
    }

    changeStatus = (status) => {
        Pop.showConfirm(<><L>Change status to:</L> <strong>{status}</strong></>, <L>Work Order</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/workorder/status/change?to=' + status, this.state.item);
                if (!j.errorCode) {
                    this.setState({ item: j.item });
                    this.success('Status changed to: ' + status);
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    submitHours = async (hours, minutes) => {
        this.setState({ submittingHours: true });
        try {
            let j = await qreq.postAsync('/api/workorder/hours/submit', { ...this.state.item, _hours: hours, _minutes: minutes });
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else {
                this.success(<L>Hours submitted successfully!</L>);
                this.setState({ showLogHours: false });
                this.load();
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submittingHours: false });
    }

    commitPercentComplete = async () => {
        this.setState({ submittingPercent: true });
        try {
            let j = await qreq.postAsync('/api/workorder/percent/submit', { ...this.state.item, percentComplete: this.state._percentComplete });
            if (j.errorCode !== 0)
                this.alert(j.errorMessage);
            else {
                this.success(<L>Percent applied successfully!</L>);
                this.setState({ showEditPercentComplete: false });
                this.load();
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submittingPercent: false });
    }

    approve = () => {
        Pop.showConfirm(<L>Are you sure you want to approve this workorder?</L>, <L>Approve</L>, async () => {
            (await this.postActionAsync('/api/workorder/approve', this.state.item)) && this.success('Approved!');
            this.load();
        });
    }

    approveRollback = () => {
        Pop.showConfirm(<L>Are you sure you want to rollback the approval for this workorder?</L>, <L>Rollback</L>, async () => {
            (await this.postActionAsync('/api/workorder/approve/rollback', this.state.item)) && this.success('Rollback done!');
            this.load();
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1>Work Order</h1><LoadingAlert /></div>);


        return <div className="container-fluid">
            <h1 className="wo-name">
                <span>{this.state.item.name}</span>
                {Auth.hasRole('tasker') && (this.state.item.approved ? this.priority()
                    : <Icon icon="faCircleHalfStroke" className="text-muted" style={{ opacity: '50%' }} />)}
                {Auth.hasRole('tasker')
                    && <span>&nbsp;
                        {!this.state.item.approved && <span className="btn btn-success" onClick={this.approve}>
                            <Icon icon="faCheck" /> <L>APPROVE</L>
                        </span>}
                    </span>}
            </h1>

            <LogHoursModal
                show={this.state.showLogHours}
                onHide={() => this.setState({ showLogHours: false })}
                onSubmit={(hours, minutes) => this.submitHours(hours, minutes)}
                submitting={this.state.submittingHours}
            />

            {this.state.showEditPercentComplete && <Modal show={this.state.showEditPercentComplete} onHide={() => this.setState({ showEditPercentComplete: false })}>
                <Modal.Header>
                    <Modal.Title>
                        Percent Complete
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Slider
                        value={this.state._percentComplete}
                        onChange={(v) => this.setState({ _percentComplete: v })}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.commitPercentComplete}>
                        <Icon icon="faSave" /> Save
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showEditPercentComplete: false })}>
                        <Icon icon="faCancel" /> Cancel
                    </button>
                </Modal.Footer>
            </Modal>}

            <form onSubmit={this.submit}>

                <Breadcrumb path={[['Work Orders', 'GOBACK'], [this.props.params.id ? 'Edit' : 'New']]} />

                <AppActions>
                    <Dropdown drop="up">
                        <Dropdown.Toggle size="lg"><L>Actions</L></Dropdown.Toggle>
                        <Dropdown.Menu>
                            {Auth.hasRole('tasker') && <Dropdown.Item onClick={this.edit}><Icon icon="faEdit" /> <L>Edit</L></Dropdown.Item>}
                            {Auth.hasRole('manager') && this.state.item.approved && <Dropdown.Item onClick={this.approveRollback}><Icon icon="faArrowRotateLeft" /> <L>Rollback Approval</L></Dropdown.Item>}
                            {Auth.hasRole('tasker') && this.state.item.statusName !== 'Closed'
                                && this.state.item.assignToUserID === this.state.user?.id
                                && <Dropdown.Item onClick={() => this.changeStatus('Closed')}><Icon icon="faClose" /> <L>Close Workorder</L></Dropdown.Item>}
                        </Dropdown.Menu>
                    </Dropdown>
                </AppActions>
                <div className="row">
                    <div className="col-lg-12">
                        <Card>
                            <div className="row">
                                {Auth.hasRole('tasker') && <>
                                    {Globals.isValidDate(this.state.item.dueDate) && <div className="col-md-2">
                                        <FormLabel model={Globals.toMDYDateString(this.state.item.dueDate)} name="dueDate" label="Due Date" />
                                    </div>}
                                    <div className="col-md-3">
                                        <FormLabel model={this.state.item.account?.name} name="accountID" label="Account" />
                                    </div>
                                    <div className="col-md-3">
                                        <FormLabel model={this.state.item.project?.name} name="projectID" label="Project" />
                                    </div>
                                    {Globals.isValidDate(this.state.item.startDate) && <div className="col-md-2">
                                        <FormLabel model={Globals.toMDYDateString(this.state.item.startDate)} name="startDate" label="Start Date" />
                                    </div>}
                                </>}
                                <div className="col-md-8">
                                    <FormLabel model={this.state.item.name} name="name" label="Workorder Name" />
                                </div>
                                {Auth.hasRole('tasker') && <div className="col-md-4">
                                    <FormLabel model={this.state.item.callerName} name="callerName" label="Caller Name" />
                                </div>}
                            </div>

                            <div className="row">
                                <div className="col-md-2">
                                    <FormLabel model={this.state.item.statusName} name="statusName" label="Status" />
                                </div>
                                {Auth.hasRole('tasker') && <div className="col-md-2">
                                    <FormLabel model={this.state.item.estimatedHours} name="estimatedHours" label="Estimated Hours" />
                                </div>}
                                {Auth.hasRole('tasker') && <div className="col-md-2">
                                    <FormLabel model={this.state.item.hours + (this.state.item.minutes ? ':' + this.state.item.minutes : '')} name="hours" label="Hours Logged" />
                                </div>}
                                {Auth.hasRole('tasker') && <div className="col-md-2">
                                    <FormLabel model={this.state.item.hoursRemaining} name="hoursRemaining" label="Hours Remaining" />
                                </div>}
                                {Auth.hasRole('task-manager') && <>
                                    {this.state.item.billableHours !== 0 && <div className="col-md-2">
                                        <FormLabel model={this.state.item.billableHours} name="billableHours" label="Billable Hours" />
                                    </div>}
                                    {this.state.item.invoiceAmount !== 0 && <div className="col-md-2">
                                        <FormLabel model={Globals.formatCurrency(this.state.item.invoiceAmount)} name="invoiceAmount" label="Invoice Amount" />
                                    </div>}
                                </>}

                            </div>

                            {Auth.hasRole('tasker') && <div className="row">
                                <div className="col-md-2">
                                    <FormLabel model={this.state.item.percentComplete} name="percentComplete" label="Percent Complete" postFix="%"
                                        /*onEdit={() => this.setState({ showEditPercentComplete: true, _percentComplete: this.state.item.percentComplete })}*/ />
                                </div>
                            </div>}

                            {Auth.hasRole('tasker') && <div className="row">
                                <div className="col-md-6">
                                    <table className="table table-striped mt-1">
                                        <tbody>
                                            {this.state.item.assigns?.filter(x => x.userID).map((i, idx) => <tr key={idx}>
                                                <th style={{ width: '100px' }}>{i.stageName}</th>
                                                <td>{i.userName}</td>
                                                <td>{(i.hours || i.minutes) ? <span>{Globals.formatTime(i.hours + ':' + i.minutes)}</span> : <span className="text-muted"><s>0:00</s></span>}</td>
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-6">
                                    <FormLabel model={this.state.item.reportToName} name="reportToName" label="Report To" />
                                </div>
                            </div>}


                            {this.state.item.summary ? <div className="bg-white p-1" dangerouslySetInnerHTML={{ __html: this.processHTML(this.state.item.summary) }}></div>
                                : <div className="bg-white p-1"><i>This workorder has no summary.</i></div>}

                            <div className="list-group">
                                {this.state.item.attachments.map((i, idx) => (
                                    <div key={idx} className="list-group-item" onClick={() => this.downloadAttachment(i)} role="button">
                                        <Icon icon="faLink" /> <span>{i.name}</span>
                                    </div>
                                ))}
                            </div>


                        </Card>
                    </div>
                </div>
            </form>
            <WorkorderCommentList workorderID={this.state.item.id} />
        </div>;
    }
}

export default withParamsAndNavigate(WorkorderView);